import { Component, Fragment } from 'react';
import {
    Grid,
} from '@mui/material';
import PlayerSelect from './PlayerSelect';
import CharacterSelect from './CharacterSelect';
import PlaceSelect from './PlaceSelect';

class RaceEntryPlayer extends Component {
    constructor(props) {
      super(props);
      this.id = props.id; // Use index for tracking
    }
  
    handleUpdate = (field, value) => {
      const { onUpdate } = this.props;
      onUpdate(this.id, field, value); // Pass index to parent
    };
  
    render() {
      const { roster, grandPrixRoster, characters, numberOfPlayers, player } = this.props;
  
      return (
        <Fragment>
          <Grid item xs={12} md={5}>
            <PlayerSelect
              id={this.id}
              roster={roster}
              grandPrixRoster={grandPrixRoster}
              player={player}
              onChange={(value) => this.handleUpdate("playerId", value)}
            />
          </Grid>
          <Grid item xs={8} md={4}>
            <CharacterSelect
              id={this.id}
              characters={characters}
              player={player}
              onChange={(value) => this.handleUpdate("characterId", value)}
            />
          </Grid>
          <Grid item xs={4} md={3}>
            <PlaceSelect
              id={this.id}
              numberOfPlayers={numberOfPlayers}
              onChange={(value) => this.handleUpdate("place", value)}
            />
          </Grid>
        </Fragment>
      );
    }
  }

export default RaceEntryPlayer
